import { CardConfig } from '@affinis/smartus-components/lib/card/card.component.types';
import { Component, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AddIncidentDTO,
  CreateEmployeeNotificationDTO,
  EmploymentClient,
  EmploymentSearchResultDto,
  IncidentType,
  OptionSetClient,
} from '@core/api';
import { RoutePath } from '@core/routing/routing.types';
import { BreadcrumbService } from '@core/services/breadcrumb-service/BreadcrumbService';
import { CiamService } from '@core/services/ciam-service/ciam-service';
import { EmployeeSearchFormlyFieldService } from '@core/services/employee-search-formly-field-service/employee-search-formly-field.service';
import { FileService } from '@core/services/file-service/file.service';
import { FormlyFieldBaseService } from '@core/services/formly-service/formly-field.service';
import { LocationFormlyFieldService } from '@core/services/formly-service/location-formly-field.service';
import { IbpdiHelperService } from '@core/services/translate-service/ibpdi-helper.service';
import { TicketCreateBaseComponent } from '@features/tickets/components/ticket-create/ticket-create.base';
import {
  auxAddress,
  concerningContact,
  fileAttachments,
  incidentInformation,
  requestingContact,
  searchContact,
  searchLocation,
  targetLocation,
} from '@mandants/telekom/features/tickets/ticket-create/field-configs';
import {
  FormModes,
  TicketCreateQueryParams,
} from '@mandants/telekom/features/tickets/ticket-create/ticket-create.types';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { DocumentType } from '@shared/types/document.types';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ticket-create',
  templateUrl:
    '../../../../../app/features/tickets/components/ticket-create/ticket-create.base.html',
  styleUrls: ['./ticket-create.component.scss'],
  standalone: false,
})
export class TicketCreateTelekomComponent extends TicketCreateBaseComponent {
  public override title = '';
  public override description = '';
  public override descriptionStyle: string;
  public override descriptionContainerStyle: string;
  public override subDescription = '';
  public override subDescriptionStyle: string;
  public override subDescriptionContainerStyle: string;
  public override formFields: Array<FormlyFieldConfig> = [];
  public override successMessage: string;

  descriptionFilledForm = this.translateService.instant(
    'ticket.create.confirm.p__info_summary'
  );

  labelButton = this.translateService.instant('forward');

  canSubmitForm: boolean;

  override card: CardConfig = {
    footer: {
      button1: {
        label: this.labelButton,
        disabled: false,
        onClick: (event: any) => {
          console.log(event);
          this.canSubmitForm = this.canSubmit();
          if (this.canSubmitForm) this.validateForm();
        },
      },
    },
  };

  public isHelpdesk = false;

  public mode: FormModes;

  currentUser: EmploymentSearchResultDto;

  constructor(
    injector: Injector,
    protected fileService: FileService,
    public toastr: ToastrService,
    public locationFormlyFieldService: LocationFormlyFieldService,
    public employeeSearchFormlyFieldService: EmployeeSearchFormlyFieldService,
    protected route: ActivatedRoute,
    protected breadcrumbService: BreadcrumbService,
    private formlyFieldService: FormlyFieldBaseService,
    private ciamService: CiamService,
    protected optionSetClient: OptionSetClient,
    private ibpdiHelperService: IbpdiHelperService,
    private employmentClient: EmploymentClient
  ) {
    super(injector);

    const currentUserEmail = this.msalService.instance.getActiveAccount()
      ?.idTokenClaims?.email as string;

    let weNo: string | undefined;

    const parts = this.router.url.split('/');
    const lastPart = parts[parts.length - 1];
    this.mode = lastPart.split('?')[0] as FormModes;

    this.isContactForm = true;

    this.route.queryParams.subscribe({
      next: (params: Partial<TicketCreateQueryParams>) => {
        weNo = params.archObjId;

        if (this.mode === 'helpdesk') {
          this.loading = true;
          this.loadingMessage = this.translateService.instant('form.loading');
          this.successMessage = this.translateService.instant(
            'ticket.create.success.message_short'
          );
          this.title = this.translateService.instant(
            'ticket.create.helpdesk.title'
          );
          this.description = this.translateService.instant(
            'ticket.create.p__info_helpDeskCreate'
          );
          this.subDescription = this.translateService.instant(
            'ticket.create.p__info_helpDeskNetworkProblem'
          );
          this.descriptionStyle =
            'background-color: #E20074; color: white; border-radius: 5px; padding: 15px;';
          this.descriptionContainerStyle =
            'width: 100%; max-width: 840px; border-radius: 15px; padding: 0 15px;';
          this.subDescriptionStyle =
            'background-color: #E20074; color: white; border-radius: 5px; padding: 15px;';
          this.subDescriptionContainerStyle =
            'width: 100%; max-width: 840px; border-radius: 15px; padding: 0 15px;';

          this.employmentClient.getEmployeeByEmail(currentUserEmail).subscribe({
            next: res => {
              this.currentUser = res;
              this.isHelpdesk = true;
              this.isContactForm = false;
              this.showTicketCreateData = true;
              this.showExtraConfirmFormFields = false;
              this.formFields = this.setFormFieldsHelpdesk(
                this.mode,
                weNo,
                currentUserEmail,
                this.currentUser
              );
              this.loading = false;
              this.loadingMessage = this.translateService.instant(
                'form.loading_message'
              );
            },
            error: () => {
              this.loading = false;
              this.loadingMessage = this.translateService.instant(
                'form.loading_message'
              );
            },
          });
        } else {
          this.title = this.translateService.instant(
            'ticket.create.contactTitle'
          );
          this.description = this.translateService.instant(
            'ticket.create.p__info_contactCreate'
          );

          this.dsgvoUrl = RoutePath.PRIVACY_GENERAL;

          this.showTicketCreateData = false;
          this.showExtraConfirmFormFields = true;

          this.formFields = [
            ...this.headline(),
            ...incidentInformation(this.translateService, this.mode),
            ...fileAttachments(this.translateService),
            ...targetLocation(this.translateService),
            ...auxAddress(this.translateService),
            ...concerningContact(this.translateService),
            ...requestingContact(this.translateService),
            ...this.checkboxes(),
          ];

          this.loading = false;
        }
        this.breadcrumbService.setBreadcrumbs([{ label: this.title }]);
      },
    });
  }

  headline(): Array<FormlyFieldConfig> {
    return [
      {
        fieldGroup: [
          {
            type: 'chapter',
            props: {
              chapterTitle: this.translateService.instant(
                'ticket.create.label__confirmHeadline'
              ),
              visibleInConfirm: true,
            },
          },
        ],
      },
    ];
  }

  private checkboxes(): Array<FormlyFieldConfig> {
    return [
      {
        key: 'subscribeNewsletter',
        type: 'checkbox',
        wrappers: ['no-border'],
        defaultValue: false,
        props: {
          label: this.translateService.instant(
            'ticket.create.confirm.label__newsletter_checkbox'
          ),
          appearance: 'outline',
        },
      },
      {
        key: 'acceptDsgvo',
        type: 'checkbox',
        wrappers: ['no-border'],
        defaultValue: false,
        props: {
          label: this.translateService.instant(
            'ticket.create.confirm.label__dsgvo'
          ),
          appearance: 'outline',
          required: true,
        },
        validators: {
          validation: ['requiredTrue'],
        },
      },
    ];
  }

  override extraConfirmFormFields: Array<FormlyFieldConfig> = [
    {
      key: 'confirmContent',
      type: 'checkbox',
      wrappers: ['no-border'],
      defaultValue: false,
      props: {
        label: this.translateService.instant(
          'ticket.create.confirm.label__confirm_checkbox'
        ),
        appearance: 'outline',
      },
      validators: {
        validation: ['requiredTrue'],
      },
    },
  ];

  public onEmailChange(emails: string) {
    this.form.get('ccemail')?.setValue(emails as never);
  }

  protected canSubmit(): boolean {
    const MAX_FILE_SIZE = 20;
    if ((this.form.value as any).attachments.length === 0) {
      return true;
    }

    const at = (this.form.value as any).attachments;
    let isValidFiles = true;
    at.forEach(element => {
      if (element.attachment === undefined || element.attachment === null) {
        isValidFiles = false;
      }
    });

    if (this.isHelpdesk === true) {
      at.forEach(element => {
        element.attachmentType = DocumentType.Sonstiges;
      });
    }

    if (isValidFiles) {
      this.formlyFieldService.unsetNotSelectedFileError();
      const [isValid, message, title] = this.fileService.validateTotalFileSize(
        at,
        (accumulator, current) => accumulator + current.attachment.size,
        MAX_FILE_SIZE
      );
      if (!isValid) {
        this.toastr.error(message, title);
      }
      return isValid;
    } else {
      this.formlyFieldService.setNotSelectedFileError();
      const element = document.getElementById('fileAttachment');
      element.scrollIntoView({ behavior: 'smooth' });
    }

    return isValidFiles;
  }

  protected override prepareSubmit = data => {
    const d = data;

    if (this.isHelpdesk === true) {
      const employeeNotification: CreateEmployeeNotificationDTO = {};
      employeeNotification.incidentTitle = d.incidentTitle;
      employeeNotification.incidentDescription = d.incidentDescription;
      employeeNotification.incidentType = IncidentType.Kundenprozesse;
      employeeNotification.roomNumber = d.searchLocation.roomNumber;
      employeeNotification.structuralPart = d.searchLocation.section;
      employeeNotification.deviatingAddress = d.searchLocation.auxaddress;
      employeeNotification.floor = d.searchLocation.floor;
      employeeNotification.mails = d.ccemail;
      employeeNotification.targetLocation = {
        archObjId: d.searchLocation.searchResult.id,
      };
      employeeNotification.creator = {
        id: d.searchContact.searchResult.id,
      };

      return { employeeNotification };
    }

    if (d.incidentClass === 'Fläche extern vermieten') {
      d.incidentType = IncidentType.Mietmanagement;
    } else {
      d.incidentType = IncidentType.Eigentuemerbelange;
    }

    function setToNullIfEmpty(obj) {
      const isNullish = Object.values(obj).every(
        value => !(value !== '' && value !== null)
      );
      return isNullish ? null : obj;
    }

    if (d.targetLocation !== undefined) {
      d.targetLocation = setToNullIfEmpty(data.targetLocation);
    }

    if (
      d.concerningLocation &&
      d.concerningLocation.powerOfDisposition === 'Eigentümer'
    ) {
      d.requestingContact = d.concerningContact;
    }

    d.requestingContact.subscribeNewsletter = d.subscribeNewsletter;

    d.powerOfDisposition = d.concerningLocation?.powerOfDisposition;

    d.ciamId = this.ciamService.getCiamId();

    const incidentDTO: AddIncidentDTO = d;

    return { incidentDTO };
  };

  public override clientEndpoint = data => {
    if (this.mode == 'helpdesk') {
      return this.incidentClient.createEmployeeNotification(data);
    }
    return this.incidentClient.createIncident(data);
  };

  public setFormFieldsHelpdesk(
    mode: FormModes,
    weNo: string,
    currentUserEmail: string,
    currentUser: EmploymentSearchResultDto
  ) {
    return [
      ...incidentInformation(this.translateService, mode),
      ...fileAttachments(this.translateService, true),
      ...searchLocation(
        this.translateService,
        this.optionSetClient,
        this.cd,
        this.ibpdiHelperService,
        this.locationFormlyFieldService,
        null,
        weNo,
        this.translateService.instant(
          'location.shared.delete_location_search_tooltip'
        )
      ),
      ...searchContact(
        this.translateService,
        this.employeeSearchFormlyFieldService,
        mode,
        currentUserEmail,
        currentUser
      ),
      // ...emailcc(this.translateService, this.onEmailChange.bind(this)),
    ];
  }

  public override getStatusPath() {
    if (this.mode === 'helpdesk') {
      return '/dashboard';
    } else {
      const parts = this.router.url.split('/'); //  ['', 'ticket', 'any']
      const modulePath = parts[1];
      let newRoute = '';
      if (parts.length > 2) {
        newRoute = `/${modulePath}/status`;
      } else {
        newRoute = '/ticket/status';
      }
      return newRoute;
    }
  }
}
